import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X, Cookie } from "lucide-react";

const COOKIE_CONSENT_KEY = "krzz_cookie_consent";

export const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Show banner after a short delay for better UX
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9998] p-4 animate-slide-up">
      <div className="container-auto">
        <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-4 sm:p-6 shadow-2xl shadow-black/50 backdrop-blur-sm">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            {/* Icon */}
            <div className="hidden sm:flex w-12 h-12 bg-[#252525] rounded-xl items-center justify-center flex-shrink-0">
              <Cookie className="w-6 h-6 text-gray-400" />
            </div>

            {/* Text */}
            <div className="flex-1">
              <p className="text-gray-300 text-sm sm:text-base leading-relaxed">
                Folosim cookie-uri pentru a îmbunătăți experiența pe site. 
                Prin continuarea navigării, ești de acord cu{" "}
                <Link 
                  to="/politica-cookies" 
                  className="text-white underline underline-offset-2 hover:text-gray-300 transition-colors"
                >
                  politica noastră de cookies
                </Link>.
              </p>
            </div>

            {/* Buttons */}
            <div className="flex items-center gap-3 w-full sm:w-auto">
              <button
                onClick={handleDecline}
                className="flex-1 sm:flex-none px-5 py-2.5 text-sm font-medium text-gray-400 hover:text-white border border-[#3a3a3a] hover:border-[#4a4a4a] rounded-full transition-all duration-200"
              >
                Refuz
              </button>
              <button
                onClick={handleAccept}
                className="flex-1 sm:flex-none px-6 py-2.5 text-sm font-medium text-black bg-white hover:bg-gray-100 rounded-full transition-all duration-200"
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Animation styles */}
      <style>{`
        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(100%);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-slide-up {
          animation: slide-up 0.4s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default CookieBanner;
